module.exports = __webpack_public_path__ + "5b94d0b29c6dace401bb427c8f542b5b.jpg";